<!-- eslint-disable vue/no-v-for-template-key -->
<template>
  <div
    id="transition"
    class="transition"
  >
    <Loader :show="$store.getters.isLoading" />
    <template
      v-for="(child, index) in children"
      :key="index"
    >
      <component
        :is="child.component"
        :custom-props="child.customProps"
        :children="child.children"
      />
    </template>
  </div>
</template>

<script src="./transition.js"></script>
